export function deltaToColor(delta, maxDelta = 0.25) {
  const t = Math.min(Math.max(delta / maxDelta, 0), 1);
  if (t < 0.5) {
    const r = Math.round(255 * t * 2);
    return `rgb(${r},${Math.round(180 + 75 * (1 - t * 2))},30)`;
  }
  const u = (t - 0.5) * 2;
  return `rgb(255,${Math.round(180 * (1 - u))},30)`;
}

export function deltaToMuiColor(delta) {
  if (delta <= 0.02) return 'success';
  if (delta <= 0.08) return 'warning';
  return 'error';
}

export function deltaToBgColor(delta) {
  if (delta <= 0.02) return 'rgba(76,175,80,0.15)';
  if (delta <= 0.08) return 'rgba(255,193,7,0.12)';
  return 'rgba(244,67,54,0.12)';
}
